import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CheckinSearchSubHeaderComponent } from './checkin-search-sub-header.component';
import { StaticMsgModule } from '@lib/pipes';
import { TextTooltipModule } from '@lib/components';

@NgModule({
  declarations: [CheckinSearchSubHeaderComponent],
  imports: [CommonModule, StaticMsgModule, TextTooltipModule],
  exports: [CheckinSearchSubHeaderComponent],
})
export class CheckinSearchSubHeaderModule {}
